import Logo from "./Logo";
import { Link } from "react-router-dom";
import DjSet from "../assets/dj-set.svg";
import FeedbackIcon from "../assets/feedback-icon.svg";
import ShoppingBag from "../assets/shopping-bag.svg";
import HomeIcon from "../assets/icons/home.png";
import Icon from "./Icon";
import { useState, useEffect } from "react";
import { supabase } from "../supabaseClient";

const AdminSidebarOption = ({
  option,
  currentSlug,
  cities,
  categories,
  activeDropdown,
  setActiveDropdown,
}) => {
  const [hovering, setHovering] = useState(false);

  // Handle Events dropdown (cities)
  if (option.showCitiesDropdown) {
    return (
      <div
        onMouseEnter={() => setHovering(true)}
        onMouseLeave={() => setHovering(false)}
        className={`${
          hovering ||
          option.activeLink === currentSlug ||
          currentSlug.startsWith(option.activeLink)
            ? "bg-[#D0ADFB20]"
            : ""
        } rounded-lg`}
      >
        <button
          onClick={() => {
            setActiveDropdown(activeDropdown === option.id ? null : option.id);
          }}
          className={`p-[12px] w-full flex items-center justify-between gap-[12px] rounded-lg font-normal !text-white ${
            currentSlug.startsWith(option.activeLink)
              ? "bg-[#D0ADFB20]"
              : "hover:bg-[#D0ADFB20]"
          } hover:shadow-lg`}
        >
          <div className="flex items-center gap-[12px]">
            {typeof option.icon === "string" ? (
              <img
                src={option.icon}
                className="w-[20px] h-[20px]"
                alt={option.name}
              />
            ) : (
              option.icon
            )}
            <p className="text-[14px]">{option.name}</p>
          </div>
          <Icon
            icon={
              activeDropdown === option.id
                ? "heroicons:chevron-up"
                : "heroicons:chevron-down"
            }
            className="w-[15px] h-[15px]"
          />
        </button>

        <div
          className="pl-[32px] overflow-hidden transition-all duration-300"
          style={{
            maxHeight: activeDropdown === option.id ? "300px" : "0px",
            opacity: activeDropdown === option.id ? 1 : 0,
          }}
        >
          <div className="pr-2 max-h-[300px] overflow-y-auto custom-scrollbar">
            <Link
              to={option.link}
              className={`mb-[8px] p-[12px] flex items-center gap-[12px] rounded-lg font-normal !text-white hover:bg-[#D0ADFB20] hover:shadow-lg ${
                currentSlug === option.activeLink ? "bg-[#D0ADFB20]" : ""
              }`}
            >
              <p className="text-[14px]">All {option.name}</p>
            </Link>
            {cities.map((city) => (
              <Link
                key={city.id}
                to={`${option.link}/${city.name}`}
                className={`mb-[8px] p-[12px] flex items-center gap-[12px] rounded-lg font-normal !text-white hover:bg-[#D0ADFB20] hover:shadow-lg ${
                  currentSlug === city.name ? "bg-[#D0ADFB20]" : ""
                }`}
              >
                <p className="text-[14px]">{city.name}</p>
              </Link>
            ))}
          </div>
        </div>
      </div>
    );
  }

  // Handle Lifestyle dropdown (categories)
  if (option.showCategoriesDropdown) {
    return (
      <div
        onMouseEnter={() => setHovering(true)}
        onMouseLeave={() => setHovering(false)}
        className={`${
          hovering ||
          option.activeLink === currentSlug ||
          currentSlug.startsWith(option.activeLink)
            ? "bg-[#D0ADFB20]"
            : ""
        } rounded-lg`}
      >
        <button
          onClick={() => {
            setActiveDropdown(activeDropdown === option.id ? null : option.id);
          }}
          className={`p-[12px] w-full flex items-center justify-between gap-[12px] rounded-lg font-normal !text-white ${
            currentSlug.startsWith(option.activeLink)
              ? "bg-[#D0ADFB20]"
              : "hover:bg-[#D0ADFB20]"
          } hover:shadow-lg`}
        >
          <div className="flex items-center gap-[12px]">
            {typeof option.icon === "string" ? (
              <img
                src={option.icon}
                className="w-[20px] h-[20px]"
                alt={option.name}
              />
            ) : (
              option.icon
            )}
            <p className="text-[14px]">{option.name}</p>
          </div>
          <Icon
            icon={
              activeDropdown === option.id
                ? "heroicons:chevron-up"
                : "heroicons:chevron-down"
            }
            className="w-[15px] h-[15px]"
          />
        </button>

        <div
          className="pl-[32px] overflow-hidden transition-all duration-300"
          style={{
            maxHeight: activeDropdown === option.id ? "300px" : "0px",
            opacity: activeDropdown === option.id ? 1 : 0,
          }}
        >
          <div className="pr-2 max-h-[300px] overflow-y-auto custom-scrollbar">
            <Link
              to={option.link}
              className={`mb-[8px] p-[12px] flex items-center gap-[12px] rounded-lg font-normal !text-white hover:bg-[#D0ADFB20] hover:shadow-lg ${
                currentSlug === option.activeLink ? "bg-[#D0ADFB20]" : ""
              }`}
            >
              <p className="text-[14px]">All Deals</p>
            </Link>
            {categories.map((category) => (
              <Link
                key={category.id}
                to={`${option.link}/${category.name}`}
                className={`mb-[8px] p-[12px] flex items-center gap-[12px] rounded-lg font-normal !text-white hover:bg-[#D0ADFB20] hover:shadow-lg ${
                  currentSlug === category.name ? "bg-[#D0ADFB20]" : ""
                }`}
              >
                <p className="text-[14px]">{category.name}</p>
              </Link>
            ))}
          </div>
        </div>
      </div>
    );
  }

  // Handle regular menu items
  return (
    <Link
      to={option.link}
      className={`p-[12px] flex items-center justify-start gap-[12px] rounded-lg font-normal !text-white ${
        currentSlug === option.activeLink
          ? "bg-[#D0ADFB20]"
          : "hover:bg-[#D0ADFB20]"
      } hover:shadow-lg`}
    >
      {typeof option.icon === "string" ? (
        <img
          src={option.icon}
          className="w-[20px] h-[20px]"
          alt={option.name}
        />
      ) : (
        option.icon
      )}
      <p className="text-[14px]">{option.name}</p>
    </Link>
  );
};

const AdminSidebar = () => {
  const currentSlug = window.location.href.split("/").pop();
  const [cities, setCities] = useState([]);
  const [categories, setCategories] = useState([]);
  const [activeDropdown, setActiveDropdown] = useState(null);

  useEffect(() => {
    supabase
      .from("City")
      .select("*")
      .then((res) => {
        setCities(res.data || []);
      });

    supabase
      .from("LifestyleCategory")
      .select("*")
      .order("index", { ascending: true })
      .then((res) => {
        setCategories(res.data || []);
      });
  }, []);

  const sidebarOptions = [
    {
      id: "analytics",
      name: "Home",
      icon: HomeIcon,
      link: "/admin/analytics",
      activeLink: "analytics",
    },
    {
      id: "events",
      name: "Events",
      icon: DjSet,
      link: "/admin/events",
      activeLink: "events",
      showCitiesDropdown: true,
    },
    {
      id: "lifestyle",
      name: "Lifestyle deals",
      icon: ShoppingBag,
      link: "/admin/lifestyle",
      activeLink: "lifestyle",
      showCategoriesDropdown: true,
    },
    {
      id: "venues",
      name: "Venues",
      icon: FeedbackIcon,
      link: "/admin/venues",
      activeLink: "venues",
    },
    {
      id: "cities",
      name: "Cities",
      icon: <Icon icon="heroicons:map-pin" className="w-[20px] h-[20px]" />,
      link: "/admin/cities",
      activeLink: "cities",
    },
    {
      id: "suggestions",
      name: "Suggestions",
      icon: (
        <Icon icon="heroicons:inbox-arrow-down" className="w-[20px] h-[20px]" />
      ),
      link: "/admin/suggestions",
      activeLink: "suggestions",
    },
    {
      id: "lifestyle-categories",
      name: "Lifestyle categories",
      icon: <Icon icon="heroicons:tag" className="w-[20px] h-[20px]" />,
      link: "/admin/lifestyle-categories",
      activeLink: "lifestyle-categories",
    },
    {
      id: "tokens",
      name: "Tokens",
      icon: <Icon icon="heroicons:key" className="w-[20px] h-[20px]" />,
      link: "/admin/tokens",
      activeLink: "tokens",
    },
    {
      id: "community-chats",
      name: "Community chats",
      icon: (
        <Icon
          icon="heroicons:chat-bubble-bottom-center"
          className="w-[20px] h-[20px]"
        />
      ),
      link: "/admin/community-chats",
      activeLink: "community-chats",
    },
    {
      id: "trending-events",
      name: "Trending events",
      icon: <Icon icon="heroicons:star" className="w-[20px] h-[20px]" />,
      link: "/admin/trending-events",
      activeLink: "trending-events",
    },
    {
      id: "spin-win-events",
      name: "Spin & Win events",
      icon: <Icon icon="heroicons:sparkles" className="w-[20px] h-[20px]" />,
      link: "/admin/spin-win-events",
      activeLink: "spin-win-events",
    },
    {
      id: "internships",
      name: "Internships",
      icon: <Icon icon="heroicons:briefcase" className="w-[20px] h-[20px]" />,
      link: "/admin/internships",
      activeLink: "internships",
    },
  ];

  return (
    <div>
      <div
        className="top-0 z-[999] fixed bg-[#0B0415] shadow-lg px-[16px] py-[20px] border-[#25202E] border-r w-[0px] lg:w-[250px] h-screen text-white"
        style={{
          transition: "width 0.2s cubic-bezier(0.39, 0.575, 0.565, 1)",
        }}
      >
        <div className="flex justify-between items-center">
          <Link to="/" className="ml-3">
            <Logo className="!w-[54px]" />
          </Link>
        </div>

        <div className="flex flex-col gap-[8px] mt-[32px] h-auto sidebar-menu">
          {sidebarOptions.map((option) => (
            <AdminSidebarOption
              key={option.id}
              option={option}
              currentSlug={currentSlug}
              cities={cities}
              categories={categories}
              activeDropdown={activeDropdown}
              setActiveDropdown={setActiveDropdown}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdminSidebar;
